import { AxiosResponse } from "axios";

import { IListEntity } from "@/v1/types/global";

import { IOperator } from "../types/ClientTestTool/ClientTestTool.interface";
import { IMember } from "../types/TeamMembers/Member.interface";
import { apiClient } from "../utils/apiClient";

export const getOperatorsByQuery = async (
  query?: string,
): Promise<AxiosResponse<IListEntity<IOperator>>> => {
  return apiClient.get(`/api/v1/operators${query}`);
};

export const getTeamMembersByOperatorID = async (operatorId: string) => {
  return apiClient.get<IListEntity<{ entityId: string; entitySource: string; member: IMember[] }>>(
    `/api/v1/entity-access?entityId=${operatorId}&entitySource=OPERATOR`,
  );
};

export const unassignMembersByOperatorID = async (
  memberId: string,
  body: { entityId: string; entitySource: string },
) => {
  return apiClient.delete(`/api/v1/members/${memberId}/entity-access`, {
    data: body,
  });
};

export const assignMembersByOperatorID = async (
  memberId: string,
  body: { entityId: string; entitySource: string },
) => {
  return apiClient.post(`/api/v1/members/${memberId}/entity-access`, body);
};
